// extracted by mini-css-extract-plugin
module.exports = {"btn-add":"role-management_btn-add__dKMRR","payment_method":"role-management_payment_method__1bz7L","card":"role-management_card__3M_lG"};